import Cross from './Cross';
import { useEffect, useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
const links = [['Home', 'home'], ['About us', 'about'], ['Our faith', 'faith'], ['Gatherings', 'events']];
export default function Navbar({ toggleContact }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = (event) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);
  return <header className="site-header">
    <nav className="page-width navigation" aria-label="Main navigation">
      <a className="wordmark" href="#home" onClick={() => setOpen(false)}><Cross className="brand-cross" /><span>Rehoboth<small>ETHIOPIAN PROTESTANT CHURCH</small></span></a>
      <div className="desktop-navigation">{links.map(([label, id]) => <a key={id} href={`#${id}`}>{label}</a>)}</div>
      <button className="primary-button nav-contact" onClick={toggleContact}>Let’s connect <ArrowUpRight size={16} /></button>
      <button className="mobile-toggle" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
    </nav>
    {open && <nav id="mobile-navigation" className="mobile-navigation" aria-label="Mobile navigation">{links.map(([label, id]) => <a key={id} href={`#${id}`} onClick={() => setOpen(false)}>{label}</a>)}<button onClick={() => { setOpen(false); toggleContact(); }}>Let’s connect <ArrowUpRight size={16} /></button></nav>}
  </header>;
}
